import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useSaveOffer = function () {
    return useApiCall(function (signal, payload) { return api.offer.apiOfferDataPost(payload, { signal: signal }); }, null, true, [], { success: 'Offer saved', error: 'Failed to update offer' });
};
